import { useEffect, useState } from 'react';
import { s } from './List.styles';
import Select, { SingleValue } from 'react-select';
import { ReportFormatNumber } from '../../../func/Function';
import { ListDataProps, SortOption, SortOptions } from './data';
import Pagination from '../pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import InterestSerivce from '../../../service/Interest';
import { FilterType } from '../../search/FilterData';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';

interface ListCardProps {
  data: ListDataProps[];
  totalCount: number;
  sort: SortOption;
  setSort: (sort: SortOption) => void;
  offset?: number;
  setOffset: (offset: number) => void;
  filters?: FilterType;
  bondFilters?: any;
  limit: number;
  loading: boolean;
  page: string;
  setSelectedIdx: (idx: number) => void;
  setShowLikeModal?: (value: boolean) => void;
  setMode?: (value: string) => void;
  setSelectedItem: (value: {
    iidx: number;
    group: string;
    group_idx: number;
    level: number;
    memo: string;
  }) => void;
  activeItem: number | null;
  setActiveItem: (value: number | null) => void;
  getList: (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters?: any,
  ) => void;
}
const List = ({
  data,
  totalCount,
  sort,
  setSort,
  offset,
  setOffset,
  filters,
  bondFilters,
  limit,
  loading,
  page,
  setSelectedIdx,
  setShowLikeModal,
  setMode,
  setSelectedItem,
  activeItem,
  setActiveItem,
  getList,
}: ListCardProps) => {
  filters = filters || bondFilters;
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());
  const [expandedMemos, setExpandedMemos] = useState<Set<number>>(new Set());
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  const navigate = useNavigate();

  const toggleMemoExpand = (index: number) => {
    setExpandedMemos((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  useEffect(() => {
    if (totalCount) {
      setTotalPages(Math.ceil(totalCount / limit));
    }
  }, [totalCount]);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };
  const toggleExpand = (index: number) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const renderTags = (tags: string[], index: number) => {
    const isExpanded = expandedRows.has(index);
    const maxVisibleTags = 2;

    if (!tags || tags.length === 0) return null;

    if (isExpanded) {
      return (
        <>
          {tags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}

          <s.TagText
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(index);
            }}
          >
            <span>접기</span>
            <img
              src="/assets/images/arrow/arrow-down-gray.svg"
              alt=""
              style={{ width: '16px', transform: 'rotate(180deg)' }}
            />
          </s.TagText>
        </>
      );
    } else {
      const visibleTags = tags.slice(0, maxVisibleTags);
      const remainingCount = tags.length - maxVisibleTags;

      return (
        <>
          {visibleTags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}
          {remainingCount > 0 && (
            <s.TagText
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(index);
              }}
            >
              +{remainingCount}개
            </s.TagText>
          )}
        </>
      );
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setOffset((page - 1) * limit);
  };

  const NoDataText = () => {
    if (page === 'search') {
      return '검색 결과가 없습니다';
    }
    if (page === 'interest') {
      return '관심물건이 없습니다.';
    }
    if (page === 'recent') {
      return '최근 열람 물건이 없습니다.';
    }
  };

  const disLike = async (iidx: number) => {
    try {
      const res = await InterestSerivce.dislike(iidx);
      setActiveItem(null);
      alert('관심물건에서 삭제되었습니다.');
      if (getList && filters) {
        getList(
          offset || 0,
          sort || { value: 'DA', label: '매각기일 빠른순' },
          filters || {},
        );
      } else {
        getList(offset || 0, sort || { value: 'DA', label: '매각기일 빠른순' });
      }
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };

  useEffect(() => {
    if (offset === 0 || offset === undefined) {
      setCurrentPage(1);
    }
  }, [offset]);
  const { modalDispatch } = useModal();
  return !isLogin() ? (
    <div
      style={{
        textAlign: 'center',
        fontSize: '13px',
        color: '#616161',
        fontWeight: '500',
        padding: '16px',
        paddingBottom: '60px',
      }}
    >
      로그인 후 이용이 가능합니다.
    </div>
  ) : (
    <s.Container>
      <s.ListTop>
        <div>총 {Number(totalCount).toLocaleString()}개</div>
        <Select<SortOption>
          options={SortOptions}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          placeholder="선택"
          value={sort}
          onChange={(selectedOption: SingleValue<SortOption>) => {
            if (selectedOption) {
              setSort(selectedOption);
            }
          }}
        />
      </s.ListTop>
      {!loading && data.length > 0 && (
        <s.ListBox>
          <s.List>
            {data.map((item, index) => (
              <s.ListCard
                isActive={false}
                key={index}
                onClick={async () => {
                  // setActiveIidx(item.b_idx);
                  // setLatLng({ lat: item.lat, lng: item.lng });
                  // setSelectedItemInfo({
                  //   iidx: item.b_idx,
                  //   b_idx: item.b_idx,
                  //   type: 'b',
                  //   lat: item.lat,
                  //   lng: item.lng,
                  // });
                  // setRoadViewLatLng({ lat: item.lat, lng: item.lng });
                  if (item.type === 'a') {
                    window.open(`/auction/detail/${item.iidx2}` + 
                    (window.location.pathname.includes('/search/npl') ? '?type=b' : ''));
                  } else {
                    window.open(`/pauction/detail/${item.iidx2}`);
                  }
                  // if (await UserService.userGrade()) {
                  // } else {
                  //   modalDispatch({ type: 'USER_ALERT', payload: 'free' });
                  // }
                }}
              >
                <s.ItemInfoBox>
                  <div>
                    {item.caseno} | {item.courtname} | {item.category}
                  </div>
                  <s.ItemTypeChip
                    style={{
                      backgroundColor:
                        item.type === 'a' ? '#FFDBD6' : '#DEEDFF',
                      color: item.type === 'a' ? '#D84836' : '#0C64CE',
                    }}
                  >
                    {item.type === 'a' ? '경매' : '공매'}
                  </s.ItemTypeChip>
                </s.ItemInfoBox>
                <s.ListCardContentBox>
                  <s.CardTextBox>
                    <s.CardTitle>{item.address}</s.CardTitle>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                      }}
                    >
                      <s.CardPrice>
                        감정가 {ReportFormatNumber(item.a_price)}
                      </s.CardPrice>
                      {item.bidprice ? (
                        <s.BidPrice>
                          낙찰가 {Number(item.bidprice).toLocaleString()}원
                        </s.BidPrice>
                      ) : (
                        <s.CardPrice>
                          최저낙찰가 {ReportFormatNumber(item.minPrice)}
                        </s.CardPrice>
                      )}
                      {item.bidprice && item.a_price && item.a_per !== null && (
                        <s.BidPrice>
                          (
                          {`낙찰가율 ${item.a_per > 0 ? `+${item.a_per}` : item.a_per}%`}
                          )
                        </s.BidPrice>
                      )}
                    </div>
                  </s.CardTextBox>
                  <s.CardImgBox>
                    <div style={{ position: 'relative' }}>
                      <img
                        src={
                          item.img === null
                            ? '/assets/images/no-image.svg'
                            : item.img
                        }
                        alt=""
                        style={{
                          height: 80,
                          width: 80,
                          borderRadius: 8,
                        }}
                      />
                      <img
                        src={`/assets/images/icon/${item.is_like ? 'white-border-star' : 'white-border-gray-star'}.svg`}
                        alt=""
                        style={{
                          position: 'absolute',
                          top: 4,
                          right: 4,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (page === 'mypattern') {
                            return;
                          }
                          if (!item.is_like) {
                            setSelectedIdx(item.iidx2);
                            setShowLikeModal && setShowLikeModal(true);
                          } else {
                            handleDisLikeItem(item.iidx2);
                          }
                        }}
                      />
                    </div>

                    <s.ViewCount>
                      <img src="/assets/images/icon/view-gray.svg" alt="" />
                      <span>{item.count ?? 0}회</span>
                    </s.ViewCount>
                  </s.CardImgBox>
                </s.ListCardContentBox>
                <s.HashTagWrapper>
                  {item.bidno > 0 && item.bidno !== null && (
                    <s.BidTag>{'유찰' + item.bidno + '회'}</s.BidTag>
                  )}
                  {item.bid === '매각' && <s.BidTag>낙찰</s.BidTag>}
                  {item.bid === '신건' && (
                    <s.BidTag
                      style={{
                        color: '#1F9E54',
                        backgroundColor: '#E6F4F0',
                      }}
                    >
                      신건
                    </s.BidTag>
                  )}
                  {renderTags(
                    [
                      ...(item.viewgray2
                        ? item.viewgray2.split(' / ').filter((el) => el !== '')
                        : []),
                    ],
                    index,
                  )}
                </s.HashTagWrapper>
                {page === 'interest' && (
                  <s.InterestBox onClick={(e) => e.stopPropagation()}>
                    <s.Rating>
                      <s.RatingText>
                        {Array.from({ length: item.level }).map((_, i) => (
                          <img
                            key={i}
                            src="/assets/images/icon/star-blue.svg"
                            alt=""
                            style={{ width: 14, height: 14 }}
                          />
                        ))}
                        <span>{item.group}</span>
                      </s.RatingText>
                      <img
                        src="/assets/images/icon/meatball.svg"
                        alt=""
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveItem(
                            activeItem === item.iidx2 ? null : item.iidx2,
                          );
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                    </s.Rating>
                    <s.MemoBox>
                      <div style={{ maxWidth: 350 }}>
                        <span
                          style={{
                            width: '100%',
                            whiteSpace: expandedMemos.has(item.iidx2)
                              ? 'normal'
                              : 'nowrap',
                            overflow: expandedMemos.has(item.iidx2)
                              ? 'unset'
                              : 'hidden',
                            textOverflow: expandedMemos.has(item.iidx2)
                              ? 'unset'
                              : 'ellipsis',
                          }}
                        >
                          {item.memo}
                          {expandedMemos.has(item.iidx2) && (
                            <s.MoreText
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleMemoExpand(item.iidx2);
                              }}
                            >
                              접기
                            </s.MoreText>
                          )}
                        </span>
                      </div>
                      {!expandedMemos.has(item.iidx2) &&
                        item.memo &&
                        item.memo.length > 34 && (
                          <s.MoreText
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleMemoExpand(item.iidx2);
                            }}
                          >
                            더보기
                          </s.MoreText>
                        )}
                    </s.MemoBox>
                    {activeItem === item.iidx2 && (
                      <s.EditBox>
                        <s.EditBoxRow
                          style={{
                            borderBottom: '1px solid #E1E2E4',
                          }}
                          onClick={() => {
                            setSelectedIdx(item.iidx2);
                            setSelectedItem({
                              iidx: item.iidx2,
                              group: item.group ?? '',
                              group_idx: item.group_idx ?? 0,
                              level: item.level,
                              memo: item.memo ?? '',
                            });
                            setMode && setMode('edit');
                            setShowLikeModal && setShowLikeModal(true);
                          }}
                        >
                          <span>수정하기</span>
                          <img src="/assets/images/icon/write.svg" alt="" />
                        </s.EditBoxRow>
                        <s.EditBoxRow
                          onClick={() => {
                            handleDisLikeItem(item.iidx2);
                          }}
                        >
                          <span>삭제하기</span>
                          <img src="/assets/images/icon/trashcan.svg" alt="" />
                        </s.EditBoxRow>
                      </s.EditBox>
                    )}
                  </s.InterestBox>
                )}
              </s.ListCard>
            ))}
          </s.List>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </s.ListBox>
      )}
      {data.length === 0 && <s.Nodata>{NoDataText()}</s.Nodata>}
    </s.Container>
  );
};

export default List;
